import { useState } from "react";

import type { CommentFilterType } from "modules/streaming";

const useCommentFilter = () => {
  const [selectedCommentFilter, setSelectedCommentFilter] =
    useState<CommentFilterType>(null);

  const handleChangeCommentFilter = (filter: CommentFilterType) => {
    setSelectedCommentFilter(filter);
  };

  return {
    selectedCommentFilter,
    handleChangeCommentFilter,
  };
};

export default useCommentFilter;
